import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { APP_URL } from "@/lib/constants";

const LINKS = [
  { label: "Возможности", href: "#features" },
  { label: "ИИ-примерка", href: "#fitting" },
  { label: "Привилегии", href: "#benefits" },
  { label: "FAQ", href: "#faq" },
];

export const Navbar = ({ solid = false }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const dark = scrolled || open || solid;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-navbar"
      className="fixed top-0 left-0 right-0 z-50 transition-colors duration-500"
      style={{
        background: dark ? "rgba(6,4,10,0.82)" : "transparent",
        backdropFilter: dark ? "blur(16px)" : "none",
        WebkitBackdropFilter: dark ? "blur(16px)" : "none",
        borderBottom: dark ? "1px solid rgba(255,255,255,0.08)" : "1px solid transparent",
      }}
    >
      <nav className="pw-container flex items-center justify-between h-[72px]">
        <a
          href={solid ? "/" : "#top"}
          data-testid="navbar-logo"
          className="flex items-center"
        >
          <img
            src="/media/logo.png"
            alt="Angiolini — Italian fur coats"
            className="h-10 md:h-11 w-auto"
          />
        </a>

        <div className="hidden md:flex items-center gap-9">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={(solid ? "/" : "") + l.href}
              data-testid={`navbar-link-${l.href.slice(1)}`}
              className="text-[14px] font-medium text-white/70 hover:text-white transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
          <Link
            to="/articles"
            data-testid="navbar-link-articles"
            className="text-[14px] font-medium text-white/70 hover:text-white transition-colors duration-300"
          >
            Статьи
          </Link>
        </div>

        <div className="hidden md:block">
          <a
            href={APP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="navbar-cta-button"
            className="pw-btn pw-btn-light btn-ingot btn-ingot-sm !py-[10px] !px-6 !text-[14px]"
          >
            <span className="ingot-inner">
              <span className="ingot-label">Открыть приложение</span>
              <span className="ingot-brand" aria-hidden="true">Angiolini</span>
            </span>
          </a>
        </div>

        <button
          data-testid="navbar-mobile-toggle"
          className="md:hidden text-white p-2"
          onClick={() => setOpen(!open)}
          aria-label="Меню"
        >
          <div className="w-6 flex flex-col gap-[6px]">
            <span
              className="block h-[2px] bg-white transition-transform duration-300"
              style={{ transform: open ? "translateY(4px) rotate(45deg)" : "none" }}
            />
            <span
              className="block h-[2px] bg-white transition-transform duration-300"
              style={{ transform: open ? "translateY(-4px) rotate(-45deg)" : "none" }}
            />
          </div>
        </button>
      </nav>

      {open && (
        <div data-testid="navbar-mobile-menu" className="md:hidden pw-container pb-6 flex flex-col gap-5">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={(solid ? "/" : "") + l.href}
              onClick={() => setOpen(false)}
              className="text-[17px] font-medium text-white/80"
            >
              {l.label}
            </a>
          ))}
          <Link
            to="/articles"
            onClick={() => setOpen(false)}
            className="text-[17px] font-medium text-white/80"
          >
            Статьи
          </Link>
          <a
            href={APP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="navbar-mobile-cta"
            className="pw-btn pw-btn-light w-full"
          >
            Открыть приложение
          </a>
        </div>
      )}
    </header>
  );
};
